import axiosInstance from "./axiosInstance";

const managePermissionService = {
    change: async (id, payload) => {
        try {
            const response = await axiosInstance.post("/permissionManagement/change/" + id, payload)
            return response.data
        } catch (error) {
            throw error.response.data
        }
    },
    fetchByRole: async (role) => {
        try {
            const response = await axiosInstance.get("/permissionManagement/role/" + role)
            return response.data
        } catch (error) {
            throw error.response.data
        }
    }
}

export default managePermissionService
